export const NEW_ITEM_ENTRY_ID = -1

export const DRAG_ASSORTIMENT_ITEM_KEY = 'DRAG_ASSORTMENT_ITEM'
